import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationES from './es/translation.json'
import translationCAT from './cat/translation.json'
import translationENG from './eng/translation.json'
import translationFR from './fr/translation.json'


const resources = {
    es: {
        translation: translationES,
    },
    cat: {
        translation: translationCAT,
    },
    eng: {
        translation: translationENG,
    },
    fr:{
        translation: translationFR
    }
};


i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "eng",
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;